import { generateBreadcrumbs } from '@/utilities/router/generate-breadcrumbs';
import { generateHeader } from '@/utilities/router/generate-header';

import sidebarItems from './sidebar';

import type { RouteRecordRaw } from '@bv/router';

const settingsBreadcrumbs = generateBreadcrumbs({
  label: 'Settings',
  route: { name: 's' },
});

const settingsRoutes: RouteRecordRaw = {
  path: 'settings',
  name: 's',
  meta: {
    sidebar: sidebarItems,
    header: generateHeader('Settings'),
  },
  redirect: { name: 's-normalizer-list' },
  children: [
    {
      path: 'normalizer',
      meta: {
        breadcrumbs: settingsBreadcrumbs({
          label: 'Normalizer',
          route: { name: 's-normalizer-list' },
        }),
        redirectUnauthorized: { name: 's-normalizer-list' },
      },
      children: [
        {
          path: '',
          name: 's-normalizer-list',
          component: () => import('@/views/Main/NumberNormalizer/List.vue'),
        },
        {
          path: '',
          component: () => import('@/views/Main/NumberNormalizer/Form.vue'),
          children: [
            {
              path: 'add',
              name: 's-normalizer-add',
              meta: {
                permissions: 'write-normalizer',
              },
            },
            {
              path: 'edit/:id',
              name: 's-normalizer-edit',
              meta: {
                permissions: 'update-normalizer',
              },
            },
          ] as RouteRecordRaw[],
        },
      ],
    },
    {
      path: 'roles',
      meta: {
        breadcrumbs: settingsBreadcrumbs({
          label: 'Roles',
          route: { name: 's-roles-list' },
        }),
        redirectUnauthorized: { name: 's-roles-list' },
      },
      children: [
        {
          path: '',
          name: 's-roles-list',
          component: () => import('@/views/Main/Settings/Roles/List.vue'),
        },
        {
          path: '',
          component: () => import('@/views/Main/Settings/Roles/Form.vue'),
          children: [
            {
              path: 'add',
              name: 's-roles-add',
              meta: {
                permissions: 'write-roles-&-permissions',
              },
            },
            {
              path: 'edit/:id',
              name: 's-roles-edit',
              meta: {
                permissions: 'update-roles-&-permissions',
              },
            },
          ] as RouteRecordRaw[],
        },
      ],
    },
    {
      path: 'logs',
      name: 's-logs',
      meta: {
        breadcrumbs: settingsBreadcrumbs({
          label: 'Logs',
          route: { name: 's-logs' },
        }),
      },
      component: () => import('@/views/Main/AuditLogs/List.vue'),
    },
  ],
};

export default settingsRoutes;
